// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WLr7","controls":"styles_controls__1Wjt7","charLimit":"styles_charLimit__ZTsgE","input":"styles_input__2k-Tl","send":"styles_send__3AAr-"};